import { useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { Spin, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { fetchEmployeeReport } from "../Slices/employeereportslice";
import { DatePickerField, SelectInput, AntdButton } from "../blueplanitUtils/InputField";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { getOptionsByPath } from "../utilsdata.js";
import { REPORTS,REPORTS_BILLABLE } from "../Dropdownmanager.jsx";


const ClientsReportFilter = ({ PageChange }) => {
  const dispatch = useDispatch();
  const today = dayjs();
  const [fromDate, setFromDate] = useState(today);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

  const [toDate, setToDate] = useState(today);
  const twoMonthsAgo = dayjs().subtract(2, "month");
  const billableOptions = [{ value: true, label: "Yes" }, { value: false, label: "No" }, { value: 'Both', label: "Both" }];
  const [billable, setBillable] = useState(billableOptions[2].value);
  const [billableValue, setBillableValue] = useState(billableOptions[2].value);
  const [loading, setLoading] = useState(false);
  const initialState = { fromDate: today, toDate: today, billable: billableOptions[2] };
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);





  const handleBillableChange = (selectedValue) => {

    setBillable(selectedValue);
    setBillableValue(selectedValue);
  };

  const getISTRangeTimestamps = (fromDate, toDate) => {
    const istStartDate = new Date(fromDate);
    const istEndDate = new Date(toDate);
    istStartDate.setHours(0, 0, 0, 0);
    istEndDate.setHours(23, 59, 59, 999);
    const startDateUTC = new Date(istStartDate.getTime());
    const endDateUTC = new Date(istEndDate.getTime());

    const startTimestamp = startDateUTC.getTime().toString();
    const endTimestamp = endDateUTC.getTime().toString();

    return {
      startTimestamp,
      endTimestamp,
    };
  };

  const disableFromDate = (current) =>
    current && (current.isBefore(twoMonthsAgo) || current.isAfter(dayjs()));

  const disableToDate = (current) =>
    current && (current.isBefore(fromDate) || current.isAfter(dayjs()));



  const hasFiltersChanged = () => {
    return (
      !fromDate.isSame(initialState.fromDate, "day") ||
      !toDate.isSame(initialState.toDate, "day") ||
      billableValue !== initialState.billableValue
    );
  };

  const handleSearch = () => {
    if (hasFiltersChanged()) {
      setLoading(true);

      const { startTimestamp, endTimestamp } = getISTRangeTimestamps(fromDate, toDate);

      const filters = {
        employeeName: loginUser?.id.toString(),
        startDateTime: startTimestamp,
        endDateTime: endTimestamp,
        billable: billableValue,
      };

      dispatch(fetchEmployeeReport(filters)).finally(() => {
        setLoading(false);
      });

      initialState.fromDate = fromDate;
      initialState.toDate = toDate;
      initialState.billableValue = billableValue;
      PageChange(1);
    }
  };

  const handleSync = () => {
    setLoading(true); // Immediately show loader
    const { startTimestamp, endTimestamp } = getISTRangeTimestamps(today, today);
    const syncFilters = {
      employeeName: loginUser?.id.toString(),
      startDateTime: startTimestamp,
      endDateTime: endTimestamp,
      billable: null,
    };

    dispatch(fetchEmployeeReport(syncFilters))
      .finally(() => {
        // Reset state after dispatch completes
        setFromDate(today);
        setToDate(today);
        setBillable(billableOptions[2]);
        setBillableValue(billableOptions[2].value);
        setLoading(false);

        // Reset initial state for comparison
        initialState.fromDate = today;
        initialState.toDate = today;
        initialState.billableValue = billableOptions[2].value;

        PageChange(1);
      });
  };



  const handleClear = () => {
    if (hasFiltersChanged()) {
      setLoading(true);
      setFromDate(today);
      setToDate(today);
      setBillable(billableOptions[2]); // Default "Both"
      setBillableValue(billableOptions[2].value);
      const { startTimestamp, endTimestamp } = getISTRangeTimestamps(today, today);
      const clearFilters = {
        employeeName: loginUser?.id.toString(),
        startDateTime: startTimestamp,
        endDateTime: endTimestamp,
        billable: null,
      };

      dispatch(fetchEmployeeReport(clearFilters)).finally(() => {
        setLoading(false);
      });
    }
    initialState.fromDate = today;
    initialState.toDate = today;
    initialState.billableValue = "";
    PageChange(1);
  };

  return (
    <div style={{ gap: "15px", paddingBottom: "10px", marginBottom: "10px" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "15px",
          alignItems: "center",
        }}
      >
        {/* From Date */}
        <div style={{ marginBottom: "15px" }}>
          <DatePickerField
            label="From Date"
            value={fromDate}
            onChange={setFromDate}
            disabledDate={disableFromDate}
            placeholder="Select From Date"
            style={{ width: "150px", height: "30px" }}
            format={"DD/MM/YYYY"}
            allowClear={false}
          />
        </div>
        {/* To Date */}
        <div style={{ marginBottom: "15px" }}>
          <DatePickerField
            label="To Date"
            value={toDate}
            onChange={setToDate}
            disabledDate={disableToDate}
            placeholder="Select To Date"
            style={{ width: "150px", height: "30px" }}
            format={"DD/MM/YYYY"}
            allowClear={false}
          />
        </div>
        {/* Billable Dropdown */}
        <div style={{ marginBottom: "15px" }}>
          <SelectInput
            label="Billable"
            options={getOptionsByPath(NestedDatabucket, [REPORTS, REPORTS_BILLABLE])}
            value={billable}
            onChange={handleBillableChange}
            placeholder="Select"
            style={{ width: "100px", height: "30px" }}
          />
        </div>
        {/* Sync Button */}
        <div>
          <Tooltip title="Sync Now">
            <FontAwesomeIcon
              icon={faArrowsRotate}
              onClick={handleSync}
              style={{ fontSize: '24px', color: '#1890ff', cursor: 'pointer', marginRight: '7px' }}
            />
          </Tooltip>
        </div>
        {/* Clear Button */}
        <div>
          <AntdButton
            label="Clear"
            onClick={handleClear}
            style={{
              width: "70px",
              height: "30px",
              backgroundColor: "#837F7F",
              color: "white",
              marginTop: "-5px",
            }}
          />
        </div>
        {/* Search Button */}
        <div>
          <AntdButton
            label="Search"
            onClick={handleSearch}
            style={{
              width: "70px",
              height: "30px",
              backgroundColor: "#007bff",
              color: "white",
              marginTop: "-5px",
            }}
          />
        </div>


      </div>
      {loading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default ClientsReportFilter;
